import React from 'react';
import { connect } from 'react-redux';
import api from '../../../utils/api';
import ResetPasswordForm from './ResetPasswordForm';
import queryString from 'query-string';

class ResetPasswordView extends React.Component {
    indexToFormat = index => {
        switch (index) {
            case 0:
                return 'f2';
            case 1:
                return 'h4_f3';
        }
    };

    onSubmit = values => {
        const qs = queryString.parse(this.props.location.search);
        values = Object.assign({}, values.toJS(), {
            reset_password_token: qs.reset_password_token,
            endpointPrefix: qs.tenant_name,
        });
        this.props.updatePassword(values);
    };

    render = () => {
        return (
            <div style={{padding:20}}>
                <h2>Password zurücksetzen</h2>
                <ResetPasswordForm
                    onSubmit={this.onSubmit}
                    isFetching={this.props.isFetching}
                    errors={this.props.errors}
                />
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({
    isFetching: state.auth.get('isFetching'),
    errors: state.auth.get('errors'),
});

const mapDispatchToProps = dispatch => ({
    updatePassword: payload => dispatch(api.actions.auth.updatePassword(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResetPasswordView);
